import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { getBrokerFrontendBootAPI } from "./brokerFrontend.api";
import { IBrokerFrontendResponseSchema } from "./brokerFrontend.types";

type IGetBrokerFrontendBootService = Omit<
  IGetAllServiceProps,
  "page" | "per_page" | "stage_id" | "filters"
>;

const useGetBrokerFrontendBootService = ({
  enableQuery = true,
  cacheKeys = [],
}: IGetBrokerFrontendBootService) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.FRONTEND_BOOT, ...cacheKeys],
    queryFn: (): Promise<{ data: IBrokerFrontendResponseSchema }> =>
      getBrokerFrontendBootAPI({}),
    enabled: enableQuery,
  });
};

export { useGetBrokerFrontendBootService };
